jQuery( document ).ready(function() {
  // Check if component is added to the page
  if( jQuery('section.text-image-slider').length ) {
    let $ = jQuery;

    $(".text-image-slider .slider-outer .content").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        speed: 1000,
        fade: true,
        asNavFor: '.text-image-slider .slider-outer .media .media-slider',
    })

    $(".text-image-slider .slider-outer .media .media-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        arrows: false,
        // speed: 2000,
        rows: 0,
        asNavFor: '.text-image-slider .slider-outer .content',
    })

  }
});
